<template>
  <div class="fill-height">
    <line-chart
      v-if="viewMode === 'chart'"
      class="fill-height"
      :raw-data="players"
      :chart-value-keys="chartValueKeys"
      x-value="last_name"
      :y-value-prefix="aggregation && !removable ? 'latest_stats.' : 'player_stats.'"
      :yaxis="[ { title: { text: $t('hr_variables.hr_bpm') }, min: 0} ]"
      :xaxis="{
        labels: {
          rotate: -45
        },
        categories: players.map(p => p.first_name[0] + '. ' + p.last_name ),
        tickPlacement: 'between'
      }"
      :colors="['#FF4560', '#df7595' ]"
      :fill="{ opacity: [1, 1]}"
    >
      <template v-slot:header>
        <v-card-title class="pa-6 d-flex justify-space-between">
          <div class="subtitle-2 grey--text text--grey-100">
            {{ $t('card_title.avg_max_heart_rate') }}{{ aggregation ? ": " + $t(`variables.${aggregation}.long`) : '' }}
          </div>
          <v-btn
            v-if="removable"
            icon
            style="pointer-events: auto"
            @click="$emit('remove')"
          >
            <v-icon small>
              fal fa-times
            </v-icon>
          </v-btn>
          <visual-list-toggle
            v-else
            :value.sync="viewMode"
          />
        </v-card-title>
      </template>
    </line-chart>

    <v-card
      v-else-if="viewMode === 'table'"
      class="fill-height rounded-lg"
    >
      <v-card-title class="pa-6 d-flex justify-space-between">
        <div class="subtitle-2 grey--text text--grey-100">
          {{ $t('card_title.avg_max_heart_rate') }}{{ aggregation ? ": " + $t(`variables.${aggregation}.long`) : '' }}
        </div>
        <div class="d-flex align-center">
          <visual-list-toggle
            v-if="!removable"
            :value.sync="viewMode"
          />
        </div>
      </v-card-title>

      <chart-list-view-table
        :headers="tableHeaders"
        :items="players"
      >
        <template v-slot:item.last_name="{ item }">
          {{ item.last_name }}, {{ item.first_name }}
        </template>
      </chart-list-view-table>
    </v-card>
  </div>
</template>

<script>
import LineChart from '@/components/charts/LineChart.vue'
import VisualListToggle from '@/components/buttons/VisualListToggle.vue'
import ChartListViewTable from '@/components/charts/implementation/ChartListViewTable.vue'

export default {
  name: 'MaxAvgHeartRateChart',
  components: { ChartListViewTable, LineChart, VisualListToggle },
  props: {
    players: {
      type: Array,
      required: true
    },
    removable: {
      type: Boolean,
      default: false
    },
    aggregation: {
      type: String,
      default: null
    }
  },
  data: () => ({
    viewMode: 'chart'
  }),
  computed: {
    chartValueKeys() {
      const addAggregation = (key) => this.aggregation && !this.removable ? `${key}_${this.aggregation}` : key
      return [
        { key: addAggregation('HRMAX'), label: this.$t('hr_variables.max_heart_rate'), type: 'line' },
        { key: addAggregation('HRAVG'), type: 'bar', label: this.$t('hr_variables.avg_heart_rate') }
      ]
    },
    tableHeaders() {
      const addAggregation = (key) => this.aggregation && !this.removable ? `${key}_${this.aggregation}` : key
      const valuePrefix = this.aggregation && !this.removable ? 'latest_stats.' : 'player_stats.'

      return [
        {
          text: this.$t('table_headers.name'),
          value: 'last_name',
          sortable: true,
          width: '40%'
        },
        {
          text: this.$t('hr_variables.max_heart_rate'),
          value: valuePrefix + addAggregation('HRMAX'),
          sortable: true,
          align: 'center'
        },
        {
          text: this.$t('hr_variables.avg_heart_rate'),
          value: valuePrefix + addAggregation('HRAVG'),
          sortable: true,
          align: 'center'
        }
      ]
    }
  }
}
</script>
